<template>
  <div class="sidebar">
    <div class="logo-container">
      <h1 class="logo-title">云游堂管理后台</h1>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="false"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        :router="true"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  name: 'Sidebar',
  components: { SidebarItem },
  computed: {
    ...mapGetters(['sidebar', 'permission_routes']),
    routes() {
      return this.permission_routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100%;

  .logo-container {
    height: 60px;
    line-height: 60px;
    background-color: #2b2f3a;
    text-align: center;
    overflow: hidden;

    .logo-title {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      margin: 0;
    }
  }

  ::v-deep .el-scrollbar {
    height: calc(100% - 60px);

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  ::v-deep .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
  }
}
</style>